import AppHeader from "@/components/AppHeader";
import dayjs from "dayjs";

export default {
  name: "csv-attendance",
  components: {
    AppHeader,
  },
  async created() {
    this.getCompany();
    this.getDepartment();
    await this.getTargetDate();
  },
  data() {
    return {
      companies: "",
      departments: [],
      selectedCompany: localStorage.company_id,
      selectedDepartment: "",
      selectedMonth: "",
      targetDates: [],
      getCompanisEnd: false,
      getDepartmentsEnd: false,
      outType: 0,
    };
  },
  methods: {
    async getCompany() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY", { data: data })
        .catch((err) => {
          console.log(err);
          return;
        });
      this.companies = res.companies;
      this.getCompanisEnd = true;
    },
    async getDepartment() {
      this.getDepartmentsEnd = false;
      let data = {
        company_id: this.selectedCompany,
      };
      let res = await this.$store
        .dispatch("GET_DEPARTMENT", { data: data })
        .catch((err) => {
          console.log(err);
          return;
        });
      this.departments = res.departments;
      this.getDepartmentsEnd = true;
    },
    getTargetDate() {
      if (this.selectedCompany == 1) {
        let targetYyyyMm = dayjs("2020-04").format("YYYY-MM");
        let endYyyyMm = dayjs().format("YYYY-MM");
        for (;;) {
          if (targetYyyyMm > endYyyyMm) break;
          this.targetDates.unshift({
            text: dayjs(targetYyyyMm).format("YYYY年MM月"),
            value: dayjs(targetYyyyMm).format("YYYY-MM"),
          });
          this.selectedMonth = dayjs(targetYyyyMm).format("YYYY-MM");
          targetYyyyMm = dayjs(targetYyyyMm)
            .add(1, "month")
            .format("YYYY-MM");
        }
      } else {
        // let today = new Date();
        let today = new Date();
        let targetYyyyMm = dayjs("2020-04").format("YYYY-MM");
        let endYyyyMm = dayjs().format("YYYY-MM");
        if (today.getDate() >= 16) {
          endYyyyMm = dayjs()
            .add(1, "month")
            .format("YYYY-MM");
        }
        for (;;) {
          if (targetYyyyMm > endYyyyMm) break;
          this.targetDates.unshift({
            text: dayjs(targetYyyyMm).format("YYYY年MM月"),
            value: dayjs(targetYyyyMm).format("YYYY-MM"),
          });
          this.selectedMonth = dayjs(targetYyyyMm).format("YYYY-MM");
          targetYyyyMm = dayjs(targetYyyyMm)
            .add(1, "month")
            .format("YYYY-MM");
        }
      }
    },
    changeCompany() {
      this.selectedDepartment = "";
      this.getDepartment();
    },
    async csvDownload() {
      if (this.outType == 1) {
        let data = {
          company_id: this.selectedCompany,
          department_id: this.selectedDepartment,
          target_month: this.selectedMonth,
        };
        let res = await this.$store
          .dispatch("GET_ATTENDANCE_CSV", { data: data })
          .catch((err) => {
            console.log(err);
            return;
          });
        this.downloadCsv(res.attendances);
      } else {
        let data = {
          company_id: this.selectedCompany,
          department_id: this.selectedDepartment,
          target_month: this.selectedMonth,
        };
        let res = await this.$store
          .dispatch("GET_ATTENDANCE_CSV_SUMMARY", { data: data })
          .catch((err) => {
            console.log(err);
            return;
          });
        this.downloadCsvSummary(res.attendances);
      }
    },
    downloadCsv: function(data) {
      let wkFileName = "出勤簿個人別" + this.selectedMonth + "分.csv";
      const csvFileName = wkFileName;
      let bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      let mimeType = "text/csv";
      let csv = "";
      // 休日の出力
      const object = data[0];
      csv += ",,,,,,,";
      if (this.selectedCompany == 1) {
        for (let day = 1; day < 32; day++) {
          const isSunday = day + "_" + "is_sunday";
          const isNotSundayHoliday = day + "_" + "is_not_sunday_holiday";
          if (object[isSunday]) {
            csv += "日曜休日";
          } else if (object[isNotSundayHoliday]) {
            csv += "法定外休日";
          } else {
            csv += "出勤日";
          }
          if (day !== 31) csv += ",";
          if (day === 31) csv += "\n";
        }
      } else {
        for (let day = 16; day < 32; day++) {
          const isSunday = day + "_" + "is_sunday";
          const isNotSundayHoliday = day + "_" + "is_not_sunday_holiday";
          if (object[isSunday]) {
            csv += "日曜休日";
          } else if (object[isNotSundayHoliday]) {
            csv += "法定外休日";
          } else {
            csv += "出勤日";
          }
          csv += ",";
        }
        for (let day = 1; day < 16; day++) {
          const isSunday = day + "_" + "is_sunday";
          const isNotSundayHoliday = day + "_" + "is_not_sunday_holiday";
          if (object[isSunday]) {
            csv += "日曜休日";
          } else if (object[isNotSundayHoliday]) {
            csv += "法定外休日";
          } else {
            csv += "出勤日";
          }
          if (day !== 15) csv += ",";
          if (day === 15) csv += "\n";
        }
      }
      data.forEach((obj) => {
        // 氏名
        csv += obj.name ? this.enquoteForCSV(obj.name) + "," : ",";

        // 出勤日数
        csv += obj.syukkin_nissu
          ? this.enquoteForCSV(obj.syukkin_nissu) + ","
          : "0,";

        // 平日時間外
        csv += obj.heijitu_zangyo
          ? this.enquoteForCSV(obj.heijitu_zangyo) + ","
          : "0,";

        // 平日深夜
        csv += obj.heijitu_shinya
          ? this.enquoteForCSV(obj.heijitu_shinya) + ","
          : "0,";

        // 休日残業
        csv += obj.kyujitu_zangyo
          ? this.enquoteForCSV(obj.kyujitu_zangyo) + ","
          : "0,";

        // 休日深夜
        csv += obj.kyujitu_shinya
          ? this.enquoteForCSV(obj.kyujitu_shinya) + ","
          : "0,";

        // 所定内深夜
        csv += obj.syoteinai_shinya
          ? this.enquoteForCSV(obj.syoteinai_shinya) + ","
          : "0,";

        // day_勤務形態
        csv = this.csvNewLine(csv, obj, "attendance_type", false);

        // day_出勤
        // csv = this.csvNewLine(csv, obj, "syukkin", false);

        // day_平日時間外
        csv = this.csvNewLine(csv, obj, "heijitu_zangyo", false);

        // day_平日深夜
        csv = this.csvNewLine(csv, obj, "heijitu_shinya", false);

        // day_休日残業
        csv = this.csvNewLine(csv, obj, "kyujitu_zangyo", false);

        // day_休日深夜
        csv = this.csvNewLine(csv, obj, "kyujitu_shinya", false);

        // day_所定内深夜
        csv = this.csvNewLine(csv, obj, "syoteinai_shinya", true);
      });
      const blob = new Blob([bom, csv], { type: mimeType });
      let hiddenElement = document.createElement("a");
      hiddenElement.download = csvFileName;
      hiddenElement.target = "_blank";
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, csvFileName);
      } else if (window.URL && window.URL.createObjectURL) {
        hiddenElement.href = window.URL.createObjectURL(blob);
        document.body.appendChild(hiddenElement);
        hiddenElement.click();
        document.body.removeChild(hiddenElement);
      } else if (window.webkitURL && window.webkitURL.createObject) {
        hiddenElement.href = (window.URL || window.webkitURL).createObjectURL(
          blob
        );
        hiddenElement.click();
      }
    },
    csvNewLine(csvData, obj, column, isLast) {
      if (this.selectedCompany == 1) {
        for (let day = 1; day < 32; day++) {
          const columName = day + "_" + column;
          if (day === 31) {
            csvData += obj[columName]
              ? this.enquoteForCSV(obj[columName])
              : "0";
          } else {
            csvData += obj[columName]
              ? this.enquoteForCSV(obj[columName]) + ","
              : "0,";
          }
        }
      } else {
        for (let day = 16; day < 32; day++) {
          const columName = day + "_" + column;
          csvData += obj[columName]
            ? this.enquoteForCSV(obj[columName]) + ","
            : "0,";
        }
        for (let afterday = 1; afterday < 16; afterday++) {
          const columName = afterday + "_" + column;
          if (afterday === 15) {
            csvData += obj[columName]
              ? this.enquoteForCSV(obj[columName])
              : "0";
          } else {
            csvData += obj[columName]
              ? this.enquoteForCSV(obj[columName]) + ","
              : "0,";
          }
        }
      }
      csvData += "\n";
      if (!isLast) {
        for (let kaigyo = 0; kaigyo < 7; kaigyo++) {
          csvData += ",";
        }
      }
      return csvData;
    },
    downloadCsvSummary: function(data) {
      let wkFileName = "出勤簿部署合計" + this.selectedMonth + "分.csv";
      const csvFileName = wkFileName;
      let bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      let mimeType = "text/csv";
      let csv =
        "部門,人数,平日残業,平日深夜,休日残業,休日深夜,所定内深夜,パート時間数\n";
      data.forEach((obj) => {
        if (obj.department_name) {
          csv += this.enquoteForCSV(obj.department_name) + ",";
        } else {
          csv += ",";
        }
        if (obj.ninzu) {
          csv += this.enquoteForCSV(obj.ninzu) + ",";
        } else {
          csv += "0,";
        }
        if (obj.heijitu_zangyo) {
          csv += this.enquoteForCSV(obj.heijitu_zangyo) + ",";
        } else {
          csv += "0,";
        }
        if (obj.heijitu_shinya) {
          csv += this.enquoteForCSV(obj.heijitu_shinya) + ",";
        } else {
          csv += "0,";
        }
        if (obj.kyujitu_zangyo) {
          csv += this.enquoteForCSV(obj.kyujitu_zangyo) + ",";
        } else {
          csv += "0,";
        }
        if (obj.kyujitu_shinya) {
          csv += this.enquoteForCSV(obj.kyujitu_shinya) + ",";
        } else {
          csv += "0,";
        }
        if (obj.syoteinai_shinya) {
          csv += this.enquoteForCSV(obj.syoteinai_shinya) + ",";
        } else {
          csv += "0,";
        }
        if (obj.part_jikan) {
          csv += this.enquoteForCSV(obj.part_jikan);
        } else {
          csv += "0";
        }
        csv += "\n";
      });
      const blob = new Blob([bom, csv], { type: mimeType });
      let hiddenElement = document.createElement("a");
      hiddenElement.download = csvFileName;
      hiddenElement.target = "_blank";
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, csvFileName);
      } else if (window.URL && window.URL.createObjectURL) {
        hiddenElement.href = window.URL.createObjectURL(blob);
        document.body.appendChild(hiddenElement);
        hiddenElement.click();
        document.body.removeChild(hiddenElement);
      } else if (window.webkitURL && window.webkitURL.createObject) {
        hiddenElement.href = (window.URL || window.webkitURL).createObjectURL(
          blob
        );
        hiddenElement.click();
      }
    },
    enquoteForCSV: function(val) {
      if (!val) return val;
      if (/[",\r\n]/.test(val)) {
        //",\r\nが含まれる場合はenquoteする
        val = '"' + val.replace(/"/g, '""') + '"';
      }
      return val;
    },
  },
};
